<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: utils.in_rem(12px);
    padding-bottom: utils.in_rem(12px);

    > img {
      height: utils.in_rem(40px);
      width: utils.in_rem(40px);
      object-fit: contain;
      border-radius: 8px;
    }

    > .header-and-name {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(1px);

      > .header {
        display: block;
        @include mixins.body2();
      }

      > .name {
        display: block;
        @include mixins.h4();
      }
    }
  }
</style>

<script>
  import Logo from "../Logo.svelte";

  export let logo;
  export let name;
</script>

<div class="container">
  <div>
    {#key logo}
      <Logo size="medium" {logo} />
    {/key}
  </div>
  <div class="header-and-name">
    <div class="header">Subsidiary of</div>
    <div class="name">{name}</div>
  </div>
</div>
